import React from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';
import SidebarMobile from './SidebarMobile';
import SidebarDesktop from './SidebarDesktop';

const Sidebar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return isMobile ? <SidebarMobile /> : <SidebarDesktop />;
};

export default Sidebar;